import { SettingsParser } from "./settings-parser";
import { MarkCommonSettings } from "../settings/mark-common-settings";

export class CommonMarkParser extends SettingsParser {
  constructor() {
    super();
    this.parsedFieldNames = [
      "id",
      "name"
    ];
  }

  static createSettings(settings) {
    if (settings === undefined) {
      return undefined;
    }
    const parsedSettings = {
      id: settings.id, // type: int
      name: settings.name // type: string
    };
    return parsedSettings;
  }

  parse(settings, defaultSettings) {
    const parsedSettings = CommonMarkParser.createSettings(settings);
    if (parsedSettings === undefined) {
      return undefined;
    }
    SettingsParser.parseRestFields(settings, defaultSettings, this.parsedFieldNames, parsedSettings);
    return new MarkCommonSettings(parsedSettings);
  }
}
